
export const sex = {
    1: '男',
    2: '女'
}

export const whether = {
    1: '是',
    0: '否'
}

export const degreeStatus = {
    0: '待提交',
    1: '待审核',
    2: '审核通过',
    3: '审核不通过',
    4: '打回修改',
    5: '通过现场验证',
}

export const degreexxxs = {
    11: '自考全日制专科',
    12: '自考全日制专升本',
    14: '自考非全日制专科',
    15: '自考非全日制专升本',
}
export const degreeLanguage = {
    'CH': '中文',
    'EN': '英文'
}
export const degreeEflType = {
    '1': '全国大学英语四级(CET-4)',
    '2': '全国大学英语六级(CET-6)',
    '3': '自考英语(专升本)代码13000',
    '4': '自考英语(二)代码00015',
    '5': '全国公共英语等级三级(PETS3)及以上',
    '6': '西南科技大学英语水平测试',
}

/** 学位申请状态：0待初审、1待终审、2通过、3暂不通过、5不通过 */
export const degreeApplyStatus = {
  '0': '待初审',
  '1': '待终审',
  '2': '通过',
  '3': '暂不通过',
  '5': '不通过',
}

/** 论文审核状态（enrollStatus）：4待资格通过、0待论文评审、1打回修改、2通过、5不通过 */
export const degreeThesisEnrollStatus = {
  '4': '待资格通过',
  '0': '待论文评审',
  '1': '打回修改',
  '2': '通过',
  '5': '不通过',
}

/** 学术复核状态：0待复核、1已复核 */
export const degreeAcademicReviewStatus = {
  '0': '待复核',
  '1': '已复核',
}

/** 学位申请最终结论：0不通过、1通过 */
export const degreeApplyFinalStatus = {
  '0': '不通过',
  '1': '通过',
}


export const o_fee_type = {
  'MIANSHOU': '面授',
  'ZXKT': '在线课堂',
  'KJXX': '课件学习',
  'SJJN': '实践技能',
  'SJJN2': '实践技能二',
  'BYLW': '毕业论文',
  'BYLW2': '毕业论文二',
  'TK': '统考报名',
  'MIANSHOU_ZB': '面授直播课',
  'ZXKT_ZB': '在线课堂直播课',
  'COURSELIVE': '公开课',
}

export const o_status = {
  'UNPAID': '未缴费',
  'PAID': '已缴费',
}

export const o_pay_way = {
  'WXPAY': '微信',
  'ALIPAY': '支付宝',
  'JHPAY': '聚合',
  'FUYI': '复翼',
}
export const quesMaps = {
  1: '单选题',
  2: '多选题',
  3: '判断题',
  4: '填空题',
  5: '问答题',
  6: '名词解释题',
  7: '论述题',
  8: '简答题',
  9: '套题'
}

export const check_status = {
  '0': '未审核',
  '1': '通过',
  '-1': '不通过',
}
export const myThesisStatus = {
  '0': '上传初稿',
  '1': '待审核',
  '2': '审核通过',
  '3': '审核不通过',
  '4': '打回修改',
}

export const defenseStatus = {
  '0': '待答辩',
  '1': '答辩通过',
  '2': '答辩不通过',
  '3': '答辩完成',
}

export const examTimes = {
  A: "星期六（9:00-11:30）",
  B: "星期六（14:00-17:30）",
  C: "星期天（9:00-11:30）",
  D: "星期天（14:00-17:30）",
  X: "星期五（9:00-11:30）",
  Y: "星期五（14:00-17:30）",
  H: "星期一（9:00-11:30）",
  I: "星期一（14:00-17:30）",
  J: "星期二（9:00-11:30）",
  K: "星期二（14:00-17:30）"
}

export const quesMap = {
  SINGLECHOICE: '单选题',
  MULTIPLECHOICE: '多选题',
  JUDGMENT: '判断题',
  BLANKFILL: '填空题',
  ESSAY: '问答题',
  MCJST: '名词解释题',
  LST: '论述题',
  JDT: '简答题',
  TT: '套题'
}

const chineseNums = ['一','二','三','四','五','六','七','八','九','十'];

export function numToChinese(n) {
  return chineseNums[n - 1] || n;
}

export function sectionTitle(section, si) {
  const questions = section.questions || [];
  const count = questions.length;
  const firstType = questions.length > 0 ? questions[0].type : '';
  const typeName = section.name || quesMap[section.questionType] || quesMap[firstType] || section.questionType || firstType || '';
  return numToChinese(si + 1) + '、' + typeName + '（共' + count + '题）';
}

export const status = {
  0: '草稿',
  1: '审核中',
  2: '待归档',
  3: '归档',
  4: '已毕业',
  5: '已注销',
  6: '已休学',
  7: '已复学',
  8: '已退学'
}

export const paperStatusMap = {
  NOTSTART: "未开始",
  STARTED: "进行中",
  SUBMITTED: "已提交",
  AUTOMATIC_REVISED: "已自动批改",
  MANUAL_REVISED: "已手动批改",
  CLOSED: "已关闭",
  EFFECT: "已生效"
}

export const ydStatus = {
  // 0: "审核不通过",
  // 1: "待审核",
  // 2: "初审通过",
  // 3: "终审通过",
  '-1':'终审不通过',
  '0':'初审不通过',
  '1':'初审待审核',
  '2':'终审待审核',
  '3':'终审通过',
  '4':'已退费',
}

/** 转专业补缴缴费状态：0-待补缴、1-已缴清、2-已撤销 */
export const supplementPayStatus = {
  0: '未缴',
  1: '已缴',
  2: '已撤销',
}

/** 转专业申请状态（展示文案） */
export const majorApplyStatus = {
  '1': '待助学点审核',
  '2': '待助学点审核',
  '3': '已通过',
  '-2': '已撤销',
  '5': '已撤销',
}

export const courseCategory = {
  'COMBASE': "公共基础课",
  'SPECCORE': "专业核心课",
  'SPECEXPAND': "专业拓展课",
  'GRADUATION': "毕业考核课",
}

export const courseType = {
  'THEORY': "理论课",
  'PRACTICE': "实训课",
  'GRADUATION': "毕业课",
}


export const examType = {
  '1': '省考',
  '2': '统考',
  '3': '实践',
  '4': '毕业考核',
}

export const edulevel = {
  'A': '专科',
  'B': '本科',
}
